




























































import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { isEmail } from "@/utils/validate";
import { computed, onMounted, Ref, ref } from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  components: {
    Modal,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: ``,
      desc: "",
      width: "50rem",
      height: "40rem",
      blank: true,
      withTopRightCloseBtn: true,
    };

    const initial_list_hash = ref("");
    const edited_email_list: Ref<string[]> = ref([]);
    const current_email = ref("");

    const is_valid_email = computed(() => {
      const email = current_email.value;
      const isValidPattern = isEmail(email);
      return isValidPattern;
    });

    const is_existing_email = computed(() => {
      return edited_email_list.value.includes(current_email.value);
    });

    const has_changes = computed(() => {
      return (
        edited_email_list.value.sort().join(",") != initial_list_hash.value
      );
    });

    const add_email = () => {
      if (is_valid_email.value && !is_existing_email.value) {
        edited_email_list.value = [
          ...edited_email_list.value,
          current_email.value,
        ];
        current_email.value = "";
      }
    };

    const remove_email = (email: string) => {
      edited_email_list.value = edited_email_list.value.filter(
        (e) => e != email
      );
    };

    const submit_changes = () => {
      emit("submit", edited_email_list.value);
    };

    onMounted(() => {
      // @ts-ignore
      initial_list_hash.value = props.modalData.emails.sort().join(",");
      // @ts-ignore
      edited_email_list.value = [...props.modalData.emails];
    });

    return {
      config,
      has_changes,
      current_email,
      add_email,
      is_valid_email,
      edited_email_list,
      remove_email,
      is_existing_email,
      submit_changes,
    };
  },
});
